import React from 'react';
import { CheckIcon } from 'lucide-react';
import { dreams } from '../data/content';
import { Reveal } from './Reveal';
const TRAINING_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/1e24e936-b109-4636-bd1e-b1481dc35cd8.jpg';
export function DreamSection() {
  return <section className="bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="metodo" data-id="element-67" data-mp="345t6l237vb9h">
      <div className="mx-auto grid max-w-6xl items-start gap-14 lg:grid-cols-[1.05fr_1fr] lg:gap-20" data-id="element-68" data-mp="2gfyuwnumvsqt">
        <div data-id="element-69" data-mp="2bh4c3lwo246p">
          <Reveal data-id="element-70" data-mp="2bhe1b79w07bc">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-71" data-mp="2bhx9vxdndjcp">
              El método 360°
            </p>
            <h2 id="metodo" className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-72" data-mp="2q7v4av2675ac">
              Imaginá que mañana entrás a la cancha y…
            </h2>
          </Reveal>

          <ul className="mt-12 space-y-8" data-id="element-73" data-mp="1sqmjrifqxalv">
            {dreams.map((dream, i) => <Reveal key={dream.title} delay={i * 0.04} data-id="element-74" data-mp="3kvy5rjmh1kv9" data-mpi={i}>
                <li className="flex gap-4" data-id="element-75" data-mp="3kvgbgsjddgpz">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-grass-soft" data-id="element-76" data-mp="3oxjlrduayf9o">
                    <CheckIcon className="h-4 w-4 text-grass" aria-hidden="true" data-id="element-77" data-mp="3to01j4llicz7" />
                  </span>
                  <div data-id="element-78" data-mp="2gxb4fdl0aq1">
                    <h3 className="text-lg font-bold text-ink" data-id="element-79" data-mp="2hgwk62fxh8t">{dream.title}</h3>
                    <p className="mt-1.5 text-[15px] leading-relaxed text-ink-soft" data-id="element-80" data-mp="31y5a92e6gd7w">
                      {dream.body}
                    </p>
                  </div>
                </li>
              </Reveal>)}
          </ul>
        </div>

        <Reveal delay={0.06} className="lg:sticky lg:top-28" data-id="element-81" data-mp="3fwvagqwamt0h">
          <figure data-id="element-82" data-mp="3fyg3ud6vg5wr">
            <img src={TRAINING_IMAGE} alt="Entrenamiento organizado: chicos trabajando en un circuito mientras el profe dirige" className="w-full rounded-xl object-cover shadow-xl" data-id="element-83" data-mp="3fusbhhd5xpjm" />
            <figcaption className="mt-4 text-sm text-ink-dim" data-id="element-84" data-mp="5hz499om30b8">
              La diferencia entre "tirar la pelota y ver qué pasa" y una práctica con
              un plan atrás.
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>;
}